module.exports = __webpack_public_path__ + "static/media/analysis.36868f6f.svg";